import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export class VeeValidateMixin extends Vue {
  getValidationState({ dirty, validated, valid = null }: {dirty: any; validated: any; valid: any}) {
    return dirty || validated ? valid : null
  }

  getValidationStateName({ dirty, validated, valid = null }: {dirty: any; validated: any; valid: any}): string {
    if (dirty || validated) {
      if (valid) return 'is-valid'

      return 'is-invalid'
    }

    return ''
  }
}
